module.exports = __webpack_public_path__ + "img/layla_yes.419f1250.png";